export default {
    NORMAL: 0,
    VISITOR: 1,
    DELETED: 2,
};
